import CASL from '@/utils/constants/casl'

export default {
  path: 'dashboard',
  children: [
    {
      path: '',
      name: 'dashboard',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.DASHBOARD
      },
      component: () => import('./dashboard/DashboardPage.vue')
    }
  ]
}
